import React from 'react'
import Dropdown from './Dropdown'
import './DropdownMix.css'
import icon from './switch.svg'

class DropdownMix extends React.Component {
  state = {
    fromValue: this.props.value[0],
    toValue: this.props.value[1],
  }

  get optionsFrom() {

   
    return this.props.options.map(item => {

      

      return {
        ...item,
        disabled: item.value === this.state.toValue || ( undefined !== this.props.disabledPairs && this.props.disabledPairs.some( el =>el.from === item.value && el.to === this.state.toValue )
        ),
      }
    })
  }

  get optionsTo() {
    return this.props.options.map(item => {
      return {
        ...item,
        disabled: item.value === this.state.fromValue || ( undefined !== this.props.disabledPairs && this.props.disabledPairs.some( el =>el.from === this.state.fromValue && el.to === item.value )
        ),
      }
    })
  }

  handleSwitch = e => {
    this.setState(prevState => ({
      fromValue: prevState.toValue,
      toValue: prevState.fromValue,
    }), this.onChange)
  }

  handleFromChange = value => this.setState({ fromValue: value }, this.onChange)
  handleToChange = value => this.setState({ toValue: value }, this.onChange)

  onChange = () => {
    const newValue = []
      .concat(this.state.fromValue)
      .concat(this.state.toValue)

    this.props.onChange(newValue)
  }

  render() {
    return (
      <div className="Dropdown-mix">
        <div className="Dropdown-mix-from">
          <Dropdown
            label="van"
            options={this.optionsFrom}
            value={this.state.fromValue}
            onChange={this.handleFromChange} />
        </div>
        <div className="Dropdown-mix-switch">
          <div onClick={this.handleSwitch}><img src={icon} alt={'Switch'} /></div>
        </div>
        <div className="Dropdown-mix-to">
          <Dropdown
            label="naar"
            options={this.optionsTo}
            value={this.state.toValue}
            onChange={this.handleToChange} />
        </div>
      </div>
    )
  }
}

export default DropdownMix



// WEBPACK FOOTER //
// ./src/content/components/dropdown/DropdownMix.js